export const FIND_TAB = 'FIND_TAB';
export const FIND_ID = 'FIND_ID';
export const FIND_PASSWD = 'FIND_PASSWD';


// WEBPACK FOOTER //
// ./src/constants/find.js